import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

import {
  CartesianDataTable,
  formatDataTableCellValue,
} from '../lib/buildChartAccessibility'

const useStyles = makeStyles({
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
  table: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  },
})

type ChartDataTableProps = {
  table: CartesianDataTable
  caption: string
  className?: string
}

export default function ChartDataTable({
  table,
  caption,
  className,
}: ChartDataTableProps): ReactElement {
  const classes = useStyles()

  return (
    <table className={clsx(classes.table, className)}>
      <caption className={classes.visuallyHidden}>{caption}</caption>
      <thead>
        <tr>
          <th scope="col">{table.categoryHeader}</th>
          {table.seriesHeaders.map((series) => (
            <th key={series.name} scope="col">
              {series.unit ? `${series.name} (${series.unit})` : series.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.rows.map((row) => (
          <tr key={row.category}>
            <th scope="row">{row.category}</th>
            {row.values.map((entry) => (
              <td key={entry.seriesName}>
                {formatDataTableCellValue(entry.value, entry.unit)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
